import { substituteTagParamaters } from "../app/utils/Tags";

export default function(text) {
    return substituteTagParamaters(text)
}
